export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.713 3.042a1 1 0 011.245 1.245l-5.4 18a1 1 0 01-1.886.084L10.23 13.77l-8.601-3.44a1 1 0 01.084-1.886l18-5.4zM5.029 9.534l5.73 2.292 2.034-2.033 1.414 1.414-2.034 2.033 2.292 5.73L18.508 5.49 5.029 9.534z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};